import emailValidator from 'email-validator';
import lodashIsEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';

const DIGITS_PATTERN = new RegExp(/^\d+$/);

const isEmpty = (val: any): boolean => lodashIsEmpty(val);

const inArray = (arr: any[], val: any): boolean => Array.isArray(arr) && arr.includes(val);

const hasValue = (val: any): boolean => !isEmpty(val);

const minLength = (val: any, min: number): boolean => isEmpty(val) || val.length >= min;

const makeMinLength =
  (min: number): any =>
  (val: any): boolean =>
    minLength(val, min);

const maxLength = (val: any, max: number): boolean => isEmpty(val) || val.length <= max;

const makeMaxLength =
  (max: number): any =>
  (val: any): boolean =>
    maxLength(val, max);

const equalsTo = (val: any, valid: any): boolean => val === valid;

const deepEqualsTo: (value: any, other: any) => boolean = isEqual;

const makeEqualsTo =
  (valid: any): any =>
  (val: any): boolean =>
    equalsTo(val, valid);

const optionalEqualsTo = (val: any, valid: any): boolean => isEmpty(val) || equalsTo(val, valid);

const makeOptionalEqualsTo =
  (valid: any): any =>
  (val: any): boolean =>
    optionalEqualsTo(val, valid);

const isEmail = (val: any): boolean => isEmpty(val) || emailValidator.validate(val);

const isNumberString = (val: any): boolean => DIGITS_PATTERN.test(val);

const hasLowercaseLetter = (val: string): boolean => RegExp('([a-z])').test(val);

const hasUppercaseLetter = (val: string): boolean => RegExp('([A-Z])').test(val);

const hasNumber = (val: string): boolean => RegExp('([0-9])').test(val);

const isIdentifierValid = (val: string): boolean => /^([a-zA-Z0-9._-])+$/g.test(val);

const hasAtLeastOneNonSpaceCharacter = (val: string): boolean => /\S/.test(val);

export {
  isIdentifierValid,
  isEmpty,
  hasValue,
  minLength,
  makeMinLength,
  maxLength,
  makeMaxLength,
  equalsTo,
  deepEqualsTo,
  makeEqualsTo,
  optionalEqualsTo,
  makeOptionalEqualsTo,
  isEmail,
  isNumberString,
  hasLowercaseLetter,
  hasUppercaseLetter,
  hasNumber,
  inArray,
  hasAtLeastOneNonSpaceCharacter,
};
